export const blockIconsBusinessandpaymentsRedeemNew = (
	<span className='material-symbols-outlined'>redeem</span>
);
